import { graphql, useStaticQuery } from 'gatsby';

const getPublicDynamicStories = () => {
  const { storyblok } = useStaticQuery(graphql`
  {
    storyblok {
      press: PagepressnewsItems(sort_by: "content.release_date:desc", filter_query_v2: {authorized_roles: {like: "[]"}}) {
        total
        items {
          full_slug
          name
          content {
            _uid
            authorized_roles
            release_date
            teaser_title
            teaser_text
            headline
            teaser_image {
              title
              filename
              copyright
              alt
            }
          }
        }
      }
      story: AktuellesItems(sort_by: "content.release_date:desc", filter_query_v2: {page_type: {like: "story"}, authorized_roles: {like: "[]"}}) {
        total
        items {
          full_slug
          name
          content {
            _uid
            teaser_title
            teaser_image {
              title
              filename
              alt
              copyright
            }
            teaser_text
            teaser_type
            authorized_roles
            release_date
            categories {
              name
              uuid
              content
            }
          }
        }
      }
      blog: AktuellesItems(sort_by: "content.release_date:desc", filter_query_v2: {page_type: {like: "blog"}, authorized_roles: {like: "[]"}}) {
        total
        items {
          full_slug
          name
          content {
            _uid
            teaser_title
            teaser_image {
              title
              filename
              alt
              copyright
            }
            teaser_text
            teaser_type
            authorized_roles
            release_date
            categories {
              name
              uuid
              content
            }
          }
        }
      }
      did: DidarticlepageItems(sort_by: "content.release_date:desc", filter_query_v2: {authorized_roles: {like: "[]"}}) {
        total
        items {
          full_slug
          name
          content {
            _uid
            teaser_title
            teaser_image {
              title
              filename
              alt
              copyright
            }
            teaser_text
            authorized_roles
            release_date
            authors {
              content
              uuid
            }
            categories {
              name
              uuid
              content
            }
          }
        }
      }
      product: PageproductItems(sort_by: "first_published_at:desc", filter_query_v2: {authorized_roles: {like: "[]"}}) {
        total
        items {
          full_slug
          first_published_at
          name
          content {
            _uid
            teaser_title
            teaser_image {
              title
              filename
              alt
              copyright
            }
            teaser_text
            authorized_roles
          }
        }
      }
    }
  }
`);
  return storyblok;
};

export { getPublicDynamicStories };
